// Locale modal

// Function to open the modal
function openModal() {
  document.getElementById("redirect_modal").style.display = "block";
}

// Function to close the modal
function closeModal() {
  document.getElementById("redirect_modal").style.display = "none";
}

// Function to check if country should be redirected
function redirectCountryCheck(locale) {
  if (locale != null && locale != "DK") {
    openModal();
    // Set the cookie to the current time
    setCookie("locale_redirect", Math.floor(Date.now() / 1000), 1);
  }
}

// Function to set a cookie
function setCookie(cname, cvalue, exhours) {
  var d = new Date();
  d.setTime(d.getTime() + exhours * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// Function to check if the modal should be displayed
function shouldDisplayModal() {
  var lastModalTime = parseInt(getCookie("locale_redirect")) || 0;
  var currentTime = Math.floor(Date.now() / 1000);
  var hoursElapsed = (currentTime - lastModalTime) / 3600;

  return hoursElapsed >= 1;
}

// Function to get the value of a cookie
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function controlModalDisplay() {
  if (shouldDisplayModal()) {
    // API request
    fetch("https://geolocation-db.com/json/")
      .then((response) => response.json())
      .then((data) => {
        if (data?.country_code) {
          redirectCountryCheck(data?.country_code);
        }
      })
      .catch((error) => console.error("Error:", error));
  }
}

// Call the controlModalDisplay function when the page is ready
document.addEventListener("DOMContentLoaded", function () {
  controlModalDisplay();

  // Listen for the close button click
  document.getElementById("closeButton").addEventListener("click", closeModal);

  // Listen for the close click on the backdrop
  document
    .getElementById("redirect_modal")
    .addEventListener("click", closeModal);
});
